<markdown 
  class="markdown" 
  [data]="val" 
  [class.is-condensed]="isCondensed"
  [class.is-flex]="isFlex"
  ngPreserveWhitespaces
></markdown>